/* PROJECT COASTLINE — HEADER TRANSPARENT */

document.addEventListener('DOMContentLoaded', () => {

  if (!document.body.classList.contains('template-index')) return;

  const header = document.querySelector('.shopify-section-group-header-group');

  if (!header) return;

  function updateHeader() {
    if (window.scrollY > 40) {
      header.classList.add('coastline-header-scrolled');
    } else {
      header.classList.remove('coastline-header-scrolled');
    }
  }

  updateHeader();

  window.addEventListener('scroll', updateHeader, {
    passive: true
  });

});